import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import api from '../services/api';
import { conVersion } from '../utils/concurrencia';

export function useEditarAntecedentes({ open, onClose, paciente, onSuccess, mostrarToast }) {
    // 1. Inicialización del gestor de formularios
    const { register, handleSubmit, reset, formState: { isSubmitting } } = useForm({
        defaultValues: {
            alergias: '',
            antecedentes: ''
        }
    });

    // 2. Hidratación: Cuando se abre el modal, cargamos los datos reales del paciente
    useEffect(() => {
        if (open && paciente) {
            reset({
                alergias: paciente.alergias || '',
                antecedentes: paciente.antecedentes || ''
            });
        }
    }, [open, paciente, reset]);

    // 3. Controlador de la API: Envío y saneamiento de datos
    const onSubmit = async (data) => {
        try {
            const limpiarValor = (valor) => (valor ? String(valor).trim() : '');

            const payload = {
                alergias: limpiarValor(data.alergias),
                antecedentes: limpiarValor(data.antecedentes)
            };

            await api.put(`/pacientes/${paciente.id || paciente._id}`, payload, conVersion(paciente));

            mostrarToast('Antecedentes clínicos actualizados con éxito', 'success');
            onClose(); // Cierra el modal
            if (onSuccess) onSuccess(); // Avisa al componente padre (PanelBiometria) para que recargue

        } catch (error) {
            mostrarToast(error.message || 'Error al actualizar antecedentes', 'error');
        }
    };

    return {
        register,
        handleSubmit,
        onSubmit,
        isSubmitting
    };
}